import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Cost = function Cost(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 16' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    id: "vF",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L2-shipping-lane-default",
    transform: "translate(-600.000000, -564.000000)",
    fill: "#4D5866",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(248.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "middle-section",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shipping-tier",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row",
    transform: "translate(8.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.000000, 8.000000)",
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128,1 C123.5815,1 120,4.5815 120,9 C120,13.4185 123.5815,17 128,17 C132.4185,17 136,13.4185 136,9 C136,4.5815 132.4185,1 128,1 Z M129.0005,13.7815 L129.0005,15 C129.0005,15.2765 128.7775,15.5 128.5005,15.5 L128.0005,15.5 C127.724,15.5 127.5005,15.2765 127.5005,15 L127.5005,13.8925 C126.5005,13.8495 125.548,13.6125 124.9335,13.3125 C124.8235,13.259 124.7335,13.1355 124.7635,13.017 L125.092,11.6755 C125.111,11.6015 125.1545,11.5395 125.2245,11.506 C125.2945,11.4735 125.3715,11.4745 125.441,11.507 C126.075,11.8095 126.89,12.0585 127.7805,12.0585 C128.6805,12.0585 129.2955,11.711 129.2955,11.08 C129.2955,10.4795 128.79,10.099 127.62,9.704 C125.93,9.1355 124.802,8.346 124.802,6.8135 C124.802,5.4225 126,4.333 127.5,4.002 L127.5,3 C127.5,2.7235 127.7235,2.5 128,2.5 L128.5,2.5 C128.7765,2.5 129,2.7235 129,3 L129,3.8905 C130,3.9315 130.587,4.106 131.086,4.319 C131.203,4.3695 131.2645,4.4965 131.2335,4.6205 L130.9045,5.904 C130.885,5.977 130.8355,6.0385 130.769,6.071 C130.7015,6.104 130.623,6.107 130.554,6.0785 C130.121,5.8965 129.469,5.6595 128.551,5.6595 C127.524,5.6595 127.192,6.102 127.192,6.5445 C127.192,7.0655 127.745,7.398 129.09,7.903 C130.969,8.5675 131.77,9.436 131.77,10.859 C131.771,12.2645 130.5005,13.4655 129.0005,13.7815 Z",
    id: "Shape"
  }))))))))));
};

Cost.displayName = 'Cost';
export default Cost;